import React from 'react'
import { View } from 'react-native'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import LocalizationContext from '../../context/LocalizationContext'
import Loading from '../../components/basic/Loading'
import OrderList from '../../components/OrderList'
import _ from 'lodash'
import EmptyView from '../../components/basic/EmptyView'


function MemberOrderListScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { orderStore, navigation, route } = props
    const { userId } = route.params
    const [isLoading, setIsLoading] = React.useState(true)
    const [search, setSearch] = React.useState(undefined)

    const orders = toJS(orderStore.memberOrders)
    const count = toJS(orderStore.memberOrderCount)

    React.useEffect(() => {
        const componentDidMount = async () => {
            try {
                await orderStore.listMemberOrders(userId, search)
            }
            catch (e) {
                console.log(e)
            }
            setIsLoading(false)
        }

        componentDidMount()
    }, [navigation])

    React.useEffect(() => {
        const onSearchChange = async () => {
            try {
                await orderStore.listMemberOrders(userId, search)
            }
            catch (e) {
                console.log(e)
            }
        }
        onSearchChange()
    }, [search])


    const handleOnEndReached = async () => {
        if (orders.length < count) {
            try {
                await orderStore.listMoreMemberOrders(orders.length, userId, search)
            }
            catch (e) {
                console.log(e)
            }
        }
    }

    if (isLoading) {
        return <Loading />
    }

    if (!toJS(orderStore.memberOrders).length) {
        return <EmptyView t={t} />
    }
    
    return (
        <OrderList
            t={t}
            orders={toJS(orderStore.memberOrders)}
            onEndReached={() => handleOnEndReached()}
            onChangeText={(value) => setSearch(value)}
            onOrderPress={(value) => { return navigation.push('OrderDetail', { orderId: value }) }}
        />
    )
}

export default inject('orderStore')(observer(MemberOrderListScreen))